import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';

import FontAwesome from 'utils/FA';

import { duckify } from "utils/duckify";
import { feeGroups, fees } from '../../ducks';

import FeeEntityDeletionModal from './FeeEntityDeletionModal';
import FeeTypeDetailsModal from './FeeTypeDetailsModal';
import FeeGroupListItemTableRowSubsection from './FeeGroupListItemTableRowSubsection';

const FeeGroupListItemTableRows = ({ feeDelete, rowData, feeRulesData }) => {
  const [showDeletionModal, setShowDeletionModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showFeesSubsection, setShowFeesSubsection] = useState(false);

  const FeesText = showFeesSubsection ? 'Hide Fees' : 'Show Fees';
  const FeesIcon = showFeesSubsection ? faCaretDown : faCaretRight;
  const feeRulesCount = feeRulesData.length;
  const feeRulesClass = feeRulesCount > 0 ? 'text-primary' : 'fee-rules-empty';

  return (
    <React.Fragment>
      <tr className="fee-details">
        <td>{rowData.name}</td>
        <td>{rowData.billing_category.name}</td>
        <td>
          <a className={feeRulesClass} onClick={() => setShowFeesSubsection(!showFeesSubsection)}>
            <span>{FeesText} ({feeRulesCount}) </span>
            <FontAwesome icon={FeesIcon} />
          </a>
        </td>
        <td>
          <div className="fee-management-actions">
            <a className="fee-edit btn btn-primary btn-sm" onClick={() => setEditModal(true)}>
              <FontAwesome icon={faPencil} />
            </a>
            <a className="fee-delete btn btn-danger btn-sm" onClick={() => setShowDeletionModal(true)}>
              <FontAwesome icon={faTrash} />
            </a>
          </div>
        </td>
      </tr>
      {showFeesSubsection &&
        <FeeGroupListItemTableRowSubsection feeID={rowData.id} />
      }

      {showDeletionModal &&
        <FeeEntityDeletionModal
          closeModal={() => setShowDeletionModal(false)}
          submitTrigger={() => feeDelete(rowData.id)}
          deletionMsg='The fee type and all associated fees will be deleted. This action cannot be reversed.'
        />
      }
      {editModal &&
        <FeeTypeDetailsModal
          closeModal={() => setEditModal(false)}
          editData={rowData}
        />
      }
    </React.Fragment>
  )
};

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feeDelete: (feeid) => {
    return dispatch(fees.actions.remove({ id: feeid })).then(() => dispatch(feeGroups.actions.markDirty()))
  }
});

FeeGroupListItemTableRows.propTypes = {
  feeDelete: PropTypes.func,
  rowID: PropTypes.string,
  feeRulesData: PropTypes.array,
  rowData: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    billing_category: PropTypes.shape({
      name: PropTypes.string
    })
  })
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupListItemTableRows);
